import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,{staticClass:"soli-btn-list"},_vm._l((_vm.items),function(item){return _c(VListItem,{key:item.value},[_c('SoliBtn',{staticClass:"my-1",attrs:{"block":"","outlined":"","text":item.name,"color":"contrast--text"},on:{"click":function($event){return _vm.$emit('input', item)}}})],1)}),1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }